export default __webpack_public_path__ + "static/media/h510_elite.431b3c34.jpg";